/* eslint-disable camelcase */
import { call, put, select, cancelled, takeLatest, takeEvery } from 'redux-saga/effects'
import { selectUser, setActivitiesStatus } from './user'
import axios from 'axios'
import API from '../config'
import { get, find } from 'lodash-es'
import { normalize } from 'normalizr'
import { activity as activitySchema } from '../schemas'

// ------------------------------------
// Constants
// ------------------------------------
const rootApi = `${API.apiPath}/${API.apiVersion}/`

export const REQUEST_ACTIVITIES = 'REQUEST_ACTIVITIES'
export const REQUEST_READ_ACTIVITIES = 'REQUEST_READ_ACTIVITIES'
export const REQUEST_READ_ACTIVITY = 'REQUEST_READ_ACTIVITY'
export const RECEIVE_ACTIVITIES = 'RECEIVE_ACTIVITIES'

// ------------------------------------
// Selectors
// ------------------------------------

export const selectActivities = getState => getState.entities.getIn(['activities', 'entities'])

// ------------------------------------
// Actions
// ------------------------------------
export const requestActivities = () => ({ type: REQUEST_ACTIVITIES })
export const requestReadActivities = () => ({ type: REQUEST_READ_ACTIVITIES })
export const requestReadActivity = payload => ({ type: REQUEST_READ_ACTIVITY, payload })

const receiveActivities = data => ({ type: RECEIVE_ACTIVITIES, payload: { data } })

function* getActivities() {
  const url = rootApi + 'notification/get-notifications'
  const user = yield select(selectUser)
  const activities = yield select(selectActivities)
  const token = get(user, 'data.auth_token')
  const CancelToken = axios.CancelToken
  const source = CancelToken.source()

  const params = {
    // start: Object.keys(activities).length ? Object.keys(activities).length + 1 : 0,
    limit: 30
  }

  try {
    const response = yield call([axios, 'get'], url, {
      headers: {
        Accept: 'application/json',
        'Authentication-Token': token,
        'Content-Type': 'application/json'
      },
      cancelToken: source.token,
      params
    })
    if (get(response, 'status') === 200) {
      let normalizedData
      const { notifications: activities } = response.data
      // set unchecked activities status for user
      const uncheckedActivity = find(activities, i => !i.opened)
      yield put(setActivitiesStatus(!!uncheckedActivity))
      normalizedData = normalize(activities, [activitySchema])
      yield put(receiveActivities(normalizedData))
    }
  } catch (e) {
  } finally {
    if (yield cancelled()) {
      source.cancel()
    }
  }
}

function* readActivities() {
  const url = rootApi + 'notification/open-notifications'
  const user = yield select(selectUser)
  const token = get(user, 'data.auth_token')
  const CancelToken = axios.CancelToken
  const source = CancelToken.source()

  try {
    const response = yield call(
      [axios, 'post'],
      url,
      {},
      {
        headers: {
          Accept: 'application/json',
          'Authentication-Token': token,
          'Content-Type': 'application/json'
        },
        cancelToken: source.token
      }
    )
    if (get(response, 'status') === 200) {
      const result = get(response, 'data.result')
      if (result === 'success') {
        yield put(requestActivities())
      }
    }
  } catch (e) {
  } finally {
    if (yield cancelled()) {
      source.cancel()
    }
  }
}

function* readActivity(action) {
  const url = rootApi + 'notification/mark-as-read'
  const user = yield select(selectUser)
  const token = get(user, 'data.auth_token')
  const CancelToken = axios.CancelToken
  const source = CancelToken.source()

  try {
    const response = yield call(
      [axios, 'post'],
      url,
      {},
      {
        headers: {
          Accept: 'application/json',
          'Authentication-Token': token,
          'Content-Type': 'application/json'
        },
        cancelToken: source.token,
        data: {
          notification_id: action.payload
        }
      }
    )
    if (get(response, 'status') === 200) {
      const result = get(response, 'data.result')
      if (result === 'success') {
        yield put(requestActivities())
      }
    }
  } catch (e) {
  } finally {
    if (yield cancelled()) {
      source.cancel()
    }
  }
}

function* getActivitiesSaga() {
  yield takeLatest(REQUEST_ACTIVITIES, getActivities)
}

function* readActivitiesSaga() {
  yield takeLatest(REQUEST_READ_ACTIVITIES, readActivities)
}

function* readActivitySaga() {
  yield takeLatest(REQUEST_READ_ACTIVITY, readActivity)
}

export const sagas = [getActivitiesSaga, readActivitiesSaga, readActivitySaga]
